import React, { PropTypes, Component } from 'react';
import cn from 'classnames';
import { FormattedMessage } from 'react-intl';
import { isEmpty, isEqual, map } from 'lodash';
import { Link } from '../visions/vx-link';

const renderValueByType = (type, data, code, categoryType) => {
  if (isEmpty(data) || isEqual(data, "null")) {
    return <span>-</span>;
  }
  if (isEqual('categoryLink', type)) {
    let query = { sort: 'date', order: 'DESC' };
    query[`gs1-gpc-${ categoryType }`] = `${ code }`;
    return <Link to={{ pathname: "/", query }} target="_blank">{data}</Link>
  } else if (isEqual('providerLink', type)) {
    return <a href={data} target="_blank">{data}</a>
  } else if (isEqual('html', type)) {
    return <div dangerouslySetInnerHTML={{ __html: data }}/>
  }
  return data;
};

export const DetailsBlockRow = ({ label, data, type, code, rowClass, thStyle, categoryType, noTranslate = false, renderNothingOnNoDataOrFalse = false }) => {
  const noData = isEmpty(data) || isEqual(data, "null") || isEqual(data, "false");
  if(noData && renderNothingOnNoDataOrFalse) return null;
  return (
    <tr className={rowClass}>
      <th style={thStyle} className="notranslate">{label}</th>
      <td className={cn({ "notranslate": noTranslate })}>{renderValueByType(type, data, code, categoryType)}</td>
    </tr>
  );
};

export class DetailsBlock extends Component {
  constructor(props) {
    super(props);

    const { switchDisplayKeys } = props;
    const isSwitchableKeys = !isEmpty(switchDisplayKeys);

    this.state = {
      isSwitchableKeys,
      currentDisplayKey: isSwitchableKeys && switchDisplayKeys[0]
    }
  }

  render() {
    const {
      title,
      tableClass,
      children,
      switchDisplayKeys,
    } = this.props;

    const {
      isSwitchableKeys,
      currentDisplayKey,
    } = this.state;
    return (
      <table className={`table ${tableClass}`}>
        <tbody>
        <tr className="info notranslate">
          <th colSpan={isSwitchableKeys ? 1 : 2}>
            {title}
          </th>
          {isSwitchableKeys && <td className="text-right">
            <FormattedMessage id="details.show"/>
            {map(switchDisplayKeys, (item, idx) => (
              <span key={item.key}>
                <a
                  onClick={e => this.setState({ currentDisplayKey: item })}
                  className="show-code"
                  style={{
                    cursor: 'pointer',
                    textDecoration: `${isEqual(item, currentDisplayKey) ? 'underline' : 'none'}`
                  }}
                >
                  <FormattedMessage id={`details.${item.label}`}/>
                </a>
                {idx < (switchDisplayKeys.length - 1) ? ' / ' : ''}
              </span>
            ))}
          </td>}
        </tr>
        {!isEmpty(currentDisplayKey) ? children({ displayKey: currentDisplayKey.key }) : children}
        </tbody>
      </table>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/recall-details/details-block.js